<template>
    <common-button v-bind="referralButtonProps" :isFluid="true" size="large" @click="performAction($event)"></common-button>
</template>

<script>
    export default {
        props: {
            type: { type: String, required: true },
            referral: { type: Object, required: true },
        },

        computed: {
            referralButtonProps() {
                let defaultProps = {
                    type: 'secondary',
                    label: this.$t('pages.referrals.index.buttons.view_referral'),
                    route: { name: `referrals.${this.type}.show`, params: { id: this.referral.id } },
                }

                if (this.type === 'received') {
                    const statuses = {
                        CREATED: {
                            type: 'primary',
                            label: this.$t('pages.referrals.index.buttons.respond'),
                            route: { name: `referrals.${this.type}.show`, params: { id: this.referral.id } },
                        },
                        CONSULTATION_NOTES_PENDING: {
                            type: 'primary',
                            label: this.$t('pages.referrals.index.buttons.add_notes'),
                            route: { path: `received/${this.referral.id}/add-report`, params: { id: this.referral.id } },
                        },
                    }

                    return statuses[this.referral.status] || defaultProps
                }

                return defaultProps
            },
        },

        methods: {
            performAction() {},
        },
    }
</script>
